export type RecordData = {
  type: string;
  hour: number;
  minute: number;
  second: number;
  // Date du record (AAAA-MM-JJ). Absente pour un calcul sans enregistrement.
  date?: string | null;
};

// Date du jour (fuseau local) au format AAAA-MM-JJ, pour les champs date.
export function aujourdhui(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

const RECORD_STORAGE_KEY = 'lastAllureRecord';

// Persiste le dernier record saisi sur l'ecran Allures, pour qu'il puisse
// etre reutilise comme reference par d'autres ecrans (ex: Construction).
export function saveLastAllureRecord(data: RecordData): void {
  try {
    sessionStorage.setItem(RECORD_STORAGE_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage indisponible : on ignore silencieusement
  }
}

export function loadLastAllureRecord(): RecordData | undefined {
  try {
    const raw = sessionStorage.getItem(RECORD_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as RecordData) : undefined;
  } catch {
    return undefined;
  }
}
